export const RaffleMiningViewsABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "OwnableInvalidOwner",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "OwnableUnauthorizedAccount",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "oldGameHistory",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "newGameHistory",
        "type": "address"
      }
    ],
    "name": "GameHistoryUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "oldRaffle",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "newRaffle",
        "type": "address"
      }
    ],
    "name": "RaffleUpdated",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "canPlay",
    "outputs": [
      {
        "internalType": "bool",
        "name": "canPlayRound",
        "type": "bool"
      },
      {
        "internalType": "string",
        "name": "reason",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "bitmap",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "containsSquare",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "bitmap",
        "type": "uint256"
      }
    ],
    "name": "countSquares",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "bitmap",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "maxSquares",
        "type": "uint256"
      }
    ],
    "name": "decodeSquaresBitmap",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "squares",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "squares",
        "type": "uint256[]"
      }
    ],
    "name": "encodeSquaresBitmap",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "gameHistory",
    "outputs": [
      {
        "internalType": "contract IGameHistory",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getActiveAutoPlayCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getAllSquaresInfo",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "totals",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getAllSquaresPlayerCounts",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "playerCounts",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "getAutoPlayInfo",
    "outputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "numberOfSquares",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "initialRounds",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "roundsPlayed",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "active",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getPendingWork",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "autoPlaysRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "pendingPlaysRemaining",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "roundReadyToFinalize",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "roundToFinalize",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributionsRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethDistributionsRemaining",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundBeingDistributed",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "singleWinnerSelectionInProgress",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "singleWinnerRound",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "currentRoundFinalized",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "vaultReservesAvailable",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "workAvailable",
            "type": "bool"
          }
        ],
        "internalType": "struct RaffleMiningTypes.PendingWork",
        "name": "work",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerAutoPlaySettings",
    "outputs": [
      {
        "internalType": "bool",
        "name": "useManualSquares",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "selectedSquaresBitmap",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "loopEthRewards",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "autoStakeWelephant",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerDetailedStats",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "totalRounds",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalPlayed",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalWon",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalWelephantWon",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "averagePlay",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundHistoryPaginated",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPlay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "won",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "squareBitmask",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "amountPerSquare",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerRoundInfo[]",
        "name": "roundInfos",
        "type": "tuple[]"
      },
      {
        "internalType": "uint256",
        "name": "nextCursor",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundIdsPaginated",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "roundIds",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256",
        "name": "nextCursor",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getPlayerRoundPerformance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "participated",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "totalPlay",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "ethWon",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "welephantWon",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "won",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "squareBitmask",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerSquareAmounts",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerSquareData",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "squareBitmask",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amountPerSquare",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "getPlayerTotalRounds",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getPlayersRoundDataBatch",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "participants",
        "type": "address[]"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundId",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalPlay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "won",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "squareBitmask",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "amountPerSquare",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerRoundInfo[]",
        "name": "infos",
        "type": "tuple[]"
      },
      {
        "internalType": "uint256",
        "name": "nextCursor",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "players",
        "type": "address[]"
      },
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getPlayersRoundPerformance",
    "outputs": [
      {
        "components": [
          {
            "internalType": "bool",
            "name": "participated",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "totalPlay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "won",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "squareBitmask",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerRoundPerformance[]",
        "name": "performances",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "name": "getRecentRounds",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundInfo",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "startTime",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "endTime",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalPot",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "finalized",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "winningSquare",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "hasMinPlayers",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "participantCount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getRoundParticipants",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getRoundParticipantsPaginated",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "participants",
        "type": "address[]"
      },
      {
        "internalType": "uint256",
        "name": "nextCursor",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundSeed",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "seed",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getRoundSummaries",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getRoundSummariesPaginated",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary[]",
        "name": "summaries",
        "type": "tuple[]"
      },
      {
        "internalType": "uint256",
        "name": "nextCursor",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "getRoundSummaryById",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint40",
            "name": "roundId",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endTime",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "startBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "endBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint40",
            "name": "closingBlock",
            "type": "uint40"
          },
          {
            "internalType": "uint256",
            "name": "totalPot",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "gameFee",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantBoughtBack",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "paydayAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winnerPayout",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantDistributed",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "winningSquare",
            "type": "uint8"
          },
          {
            "internalType": "uint32",
            "name": "totalPlayers",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "totalWinners",
            "type": "uint32"
          },
          {
            "internalType": "bool",
            "name": "isPayday",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "isSingleWinner",
            "type": "bool"
          },
          {
            "internalType": "bool",
            "name": "finalized",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "singleWinner",
            "type": "address"
          }
        ],
        "internalType": "struct GameHistoryTypes.RoundSummary",
        "name": "summary",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "getSquareInfo",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "total",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "n",
        "type": "uint256"
      }
    ],
    "name": "getTopPlayersStats",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "players",
        "type": "address[]"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "ethSpent",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundsParticipated",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "roundsWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ethWon",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "welephantWon",
            "type": "uint256"
          }
        ],
        "internalType": "struct GameHistoryTypes.PlayerStats[]",
        "name": "stats",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalRounds",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "player",
        "type": "address"
      }
    ],
    "name": "isPlayerInLeaderboard",
    "outputs": [
      {
        "internalType": "bool",
        "name": "inLeaderboard",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "roundId",
        "type": "uint256"
      }
    ],
    "name": "isRoundReadyToFinalize",
    "outputs": [
      {
        "internalType": "bool",
        "name": "ready",
        "type": "bool"
      },
      {
        "internalType": "string",
        "name": "reason",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "numSq",
        "type": "uint256"
      }
    ],
    "name": "maxBitmask",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "raffle",
    "outputs": [
      {
        "internalType": "contract IRaffleMiningStorage",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_gameHistory",
        "type": "address"
      }
    ],
    "name": "setGameHistory",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_raffle",
        "type": "address"
      }
    ],
    "name": "setRaffle",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "square",
        "type": "uint256"
      }
    ],
    "name": "squareBit",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "bitmap",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "numSq",
        "type": "uint256"
      }
    ],
    "name": "validateSquaresBitmap",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  }
] as const;
